import { render, staticRenderFns } from "./general-tab.vue?vue&type=template&id=12d3cafc"
import script from "./general-tab.vue?vue&type=script&lang=js"
export * from "./general-tab.vue?vue&type=script&lang=js"
import style0 from "./general-tab.vue?vue&type=style&index=0&id=12d3cafc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports